import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHelper } from '../helpers/http-helper';
import { IServerSettings } from '../models/serversettings';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';

@Injectable({
    providedIn: 'root'
})
export class LCRValidationService {
    private settings: IServerSettings;
    private apiUrl: string;
    private action: string;
    httpHelper: HttpHelper;
    constructor(private settingsService: SettingsService, private http: HttpClient, private authService: AuthenticationService, private storageManagerService: StorageManagerService) {
        // Define an instance of the http helper class that will be used to create httpHeader for api calls
        this.httpHelper = new HttpHelper(http, authService, storageManagerService);
    }

    validateLCR(llData: any, lcrRevisionId: number, modifiedByUser: string, hasChanges: boolean, ignoreWarnings: boolean) {
        let headers = this.httpHelper.createHttpHeaders();
        this.settings = this.settingsService.getSettings();
        this.apiUrl = this.settings.ApiGatewayUrl;
        this.action = `ssdpds/v1/LCRForms/Validate?hasChanges=${hasChanges}&lcrRevisionId=${lcrRevisionId ? lcrRevisionId : 0}&ignoreWarnings=${ignoreWarnings}`;

        headers = headers.set('modifiedByUser', modifiedByUser);

        return this.http.post(`${this.apiUrl}/${this.action}`, llData, { headers: headers })
            .pipe(map(this.extractData),
              catchError(this.handleErrors));
    }

    buildLCR(llData: any, modifiedByUser: string, ignoreWarnings: boolean, newSPLVersion: number) {
        let headers = this.httpHelper.createHttpHeaders();
        this.settings = this.settingsService.getSettings();
        this.apiUrl = this.settings.ApiGatewayUrl;
        this.action = `ssdpds/v1/LCRForms/Build?ignoreWarnings=${ignoreWarnings}&newSplVersionNumber=${newSPLVersion}`;

        headers = headers.set('modifiedByUser', modifiedByUser);

        return this.http.post(`${this.apiUrl}/${this.action}`, llData, { headers: headers })
            .pipe(map(this.extractData),
              catchError(this.handleErrors));
    }

    private extractData(response: Response) {
        if (response.status < 200 || response.status >= 300) {
            throw new Error('Bad response status: ' + response.status);
        }

        const body = response;
        return body || {};
    }

    // Error handling
    private handleErrors(error: any): Observable<any> {
      const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
      const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage ? true : isDevMode() ? true : false;
      error.error = error && error.error && error.error.message && bDisplayDetailMsg ? error.error.message : GENERIC_ERROR_MSG;

      return throwError(error.error);
    }
}

